import React from 'react';
import AddButton from '../../../../common/controls/AddButton';

import AddRow from '../../../../common/controls/AddRow';

const OptionBar: React.FC<any> = (props: any) => {
  const { handleOpenOptionForm, isReadOnlyMode } = props;

  return (
    <AddRow
      label='Alternative Make/Model'
      buttons={
        <AddButton
          disabled={isReadOnlyMode}
          label='ADD OPTION'
          onClick={handleOpenOptionForm}
        />
      }
    />
  );
};

export default OptionBar;
